"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Image_Error = void 0;

Image_Error = function () {
    var Image_Error = function () {
        function Image_Error() {
            _classCallCheck(this, Image_Error);
        }

        _createClass(Image_Error, [{
            key: "constuctor",
            value: function constuctor() {
                return $(document).ready(function () {
                    return $(".icon img").on("error", function (e) {
                        return noun.icon_list.fallbackIcon($(this));
                    });
                });
            }
        }]);

        return Image_Error;
    }();

    return Image_Error;
}();

exports.default = new Image_Error();